@if (mail) {
  <section class="verdict" [class.busy]="busy">
    <h3 class="intake-head">{{ heading | translate }}</h3>
    @switch (card) {
      @case ('over_cap') {
        <p>{{ overCapText }}</p>
        <div class="actions">
          <button nbButton size="small" status="primary" [disabled]="busy" (click)="parseNow()"
                  [nbTooltip]="'intake.panel.over_cap_hint' | translate" [title]="'intake.panel.over_cap_hint' | translate">{{ 'intake.panel.parse_now' | translate }}</button>
        </div>
      }
      @case ('burst') {
        <p>{{ 'intake.panel.burst_body' | translate }}</p>
        <div class="actions">
          <button nbButton size="small" status="primary" [disabled]="busy" (click)="release()"
                  [nbTooltip]="'intake.panel.burst_hint' | translate" [title]="'intake.panel.burst_hint' | translate">{{ 'intake.panel.release' | translate }}</button>
        </div>
      }
      @case ('parser_unavailable') {
        <p>{{ 'intake.panel.parser_unavailable_body' | translate }}</p>
        <div class="actions">
          <button nbButton size="small" status="primary" [disabled]="busy" (click)="retry()">{{ 'intake.panel.retry' | translate }}</button>
        </div>
      }
      @case ('ambiguous_match') {
        <p>{{ (candidates.length ? 'intake.panel.ambiguous_match_body' : 'intake.panel.ambiguous_match_none_found') | translate }}</p>
        <nb-radio-group [(ngModel)]="chosen" name="intake-match">
          @for (v of candidates; track v.id) {
            <nb-radio [value]="v.id"><strong>{{ v.title }}</strong></nb-radio>
          }
          <nb-radio value="none">{{ 'intake.panel.none_new' | translate }}</nb-radio>
        </nb-radio-group>
        <div class="actions">
          <button nbButton size="small" status="primary" [disabled]="busy || chosen === null" (click)="chooseMatch()">{{ 'intake.panel.choose_match' | translate }}</button>
        </div>
      }
      @case ('ambiguous_verdict') {
        <p>{{ mail.parser_reason || ('intake.panel.ambiguous_verdict_body' | translate) }}</p>
        <div class="actions">
          <button nbButton size="small" status="primary" [disabled]="busy" (click)="openForm('create')">{{ 'intake.panel.create_direct' | translate }}</button>
          <button nbButton size="small" status="basic" [disabled]="busy" (click)="notARole()">{{ 'intake.panel.not_a_role' | translate }}</button>
        </div>
      }
      @case ('direct') {
        <ng-container [ngTemplateOutlet]="directCard"></ng-container>
      }
      @case ('needs_details') {
        <p>{{ 'intake.panel.needs_details_title' | translate }}. {{ 'intake.panel.needs_details_body' | translate }}</p>
        <ng-container [ngTemplateOutlet]="directCard"></ng-container>
      }
      @case ('duplicate') {
        <p>{{ 'intake.panel.duplicate_body' | translate }}</p>
        @if (mail.vacancy) {
          <div class="actions">
            <a nbButton size="small" status="primary" [routerLink]="['/market/vacancies', mail.vacancy.id]">{{ 'intake.panel.open_request' | translate }}</a>
          </div>
        }
      }
      @case ('not_a_role') {
        @if (mail.parser_reason) { <p>{{ mail.parser_reason }}</p> }
        <div class="actions">
          <button nbButton size="small" status="primary" [disabled]="busy" (click)="openForm('create')"
                  [nbTooltip]="'intake.panel.not_a_role_body' | translate" [title]="'intake.panel.not_a_role_body' | translate">{{ 'intake.panel.make_direct' | translate }}</button>
        </div>
      }
      @case ('update') {
        @if (!mail.vacancy) {
          <p class="hint">{{ 'intake.panel.vacancy_gone' | translate }}</p>
        } @else if (updateRows.length) {
          <table class="diff">
            <thead>
              <tr>
                <th>{{ 'intake.update.field' | translate }}</th>
                <th>{{ 'intake.update.now' | translate }}</th>
                <th>{{ 'intake.update.in_mail' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (row of updateRows; track row.field) {
                <tr>
                  <td class="field">{{ row.label | translate }}</td>
                  <td>{{ row.now === null ? '-' : (row.date ? (row.now | intakeDate: 'dayYear') : row.now) }}</td>
                  <td class="new">{{ row.next === null ? '-' : (row.date ? (row.next | intakeDate: 'dayYear') : row.next) }}</td>
                </tr>
              }
            </tbody>
          </table>
          @if (unchangedText) {
            <p class="hint">{{ 'intake.update.no_change' | translate: { fields: unchangedText } }}</p>
          }
        } @else {
          <p>{{ 'intake.update.nothing_changed' | translate }}</p>
        }
        @if (!mail.update_state) {
          <div class="actions">
            <button nbButton size="small" status="primary" [disabled]="busy || !vacancy" (click)="openForm('edit')"
                    [nbTooltip]="'intake.update.read_only' | translate" [title]="'intake.update.read_only' | translate">{{ 'intake.update.edit' | translate }}</button>
            <button nbButton size="small" status="basic" [disabled]="busy" (click)="markApplied()">{{ 'intake.update.mark_applied' | translate }}</button>
            <button nbButton size="small" status="basic" [disabled]="busy" (click)="ignoreUpdate()">{{ 'intake.update.ignore' | translate }}</button>
          </div>
          <p class="hint expires">{{ 'intake.update.expires' | translate }}</p>
        } @else if (mail.vacancy) {
          <div class="actions">
            <a nbButton size="small" status="basic" [routerLink]="['/market/vacancies', mail.vacancy.id]">{{ 'intake.panel.open_request' | translate }}</a>
          </div>
        }
      }
      @case ('system') {
        <p>{{ 'intake.panel.system_body' | translate }}</p>
      }
      @case ('pending') {
        <p>{{ 'intake.panel.pending_body' | translate }}</p>
      }
      @case ('expired') {
        <p>{{ 'intake.panel.expired_body' | translate }}</p>
      }
    }
    <!-- Notes not tied to a listed field: plain muted lines at the bottom of the details. -->
    @if (looseNotes.length) {
      <ul class="notes">
        @for (n of looseNotes; track $index) {
          <li>{{ noteKey(n) | translate: noteParams(n) }}</li>
        }
      </ul>
    }
  </section>
}

<ng-template #directCard>
  @if (mail.vacancy && !vacancy) {
    <p class="hint">{{ 'intake.panel.vacancy_gone' | translate }}</p>
  }
  <div class="detail-rows">
    @for (row of fieldRows; track row.key) {
      <div class="detail-row">
        <span class="detail-label">{{ row.label | translate }}</span>
        <span class="detail-value">{{ row.value === null ? '-' : (row.date ? (row.value | intakeDate: 'dayYear') : row.value) }}</span>
        @for (n of row.notes; track $index) {
          <span class="field-note">{{ noteKey(n) | translate: noteParams(n) }}</span>
        }
      </div>
    }
    <div class="detail-row buyer">
      <label class="detail-label" for="intake-buyer">{{ 'intake.panel.crm_client' | translate }}</label>
      <div class="detail-value buyer-pick">
        <input nbInput fullWidth fieldSize="small" type="text" id="intake-buyer" autocomplete="off"
               [nbAutocomplete]="buyerAuto" [value]="buyerLabel"
               [placeholder]="'intake.panel.crm_client_none' | translate" [disabled]="busy || !vacancy"
               [title]="buyers.length >= buyerPage ? ('intake.panel.buyer_more' | translate: { count: buyerPage }) : ''"
               (input)="searchBuyers($any($event.target).value)">
        <nb-autocomplete #buyerAuto [handleDisplayFn]="buyerName" (selectedChange)="pickBuyer($event)">
          @for (b of buyerOptions; track b.id) {
            <nb-option [value]="b.id">{{ b.name }}</nb-option>
          }
        </nb-autocomplete>
        <button nbButton ghost size="small" status="primary" class="link-button" [disabled]="busy || !vacancy" (click)="newProspect()">
          {{ 'intake.panel.new_prospect' | translate }}
        </button>
      </div>
    </div>
  </div>
  <div class="actions verdict-actions">
    @if (mail.vacancy) {
      <a nbButton size="small" status="primary" [routerLink]="['/market/vacancies', mail.vacancy.id]">{{ 'intake.panel.open_request' | translate }}</a>
    }
    <button nbButton size="small" status="basic" [disabled]="busy || !vacancy" (click)="openForm('edit')">{{ 'intake.panel.edit_details' | translate }}</button>
    @if (canOverturn) {
      <button nbButton size="small" status="basic" [disabled]="busy" (click)="notARole()">{{ 'intake.panel.not_a_role' | translate }}</button>
    }
  </div>
</ng-template>
